import {tokens} from '../generated/light';

type ShadowToken = {
  x: string | number;
  y: string | number;
  blur: string | number;
  spread: string | number;
  color: string;
};

// TODO: move to transform?
export const toShadow = (shadow: ShadowToken) =>
  `${typeof shadow.x === `number` ? `${shadow.x}px` : shadow.x} ${
    typeof shadow.y === `number` ? `${shadow.y}px` : shadow.y
  } ${typeof shadow.blur === `number` ? `${shadow.blur}px` : shadow.blur} ${
    typeof shadow.spread === `number` ? `${shadow.spread}px` : shadow.spread
  } ${shadow.color}`;

export const shadows = {
  xs: toShadow(tokens.core.shadows[`shadow-xs`]),
  sm: `${toShadow(tokens.core.shadows[`shadow-s-1`])}, ${toShadow(tokens.core.shadows[`shadow-s-2`])}`,
  md: `${toShadow(tokens.core.shadows[`shadow-m-1`])}, ${toShadow(tokens.core.shadows[`shadow-m-2`])}`,
  lg: `${toShadow({...tokens.core.shadows[`shadow-l-1`], color: `rgba(0, 0, 0, 0.08)`})}, ${toShadow({
    ...tokens.core.shadows[`shadow-l-2`],
    color: `rgba(0, 0, 0, 0.06)`,
  })}`,
  xl: `${toShadow({...tokens.core.shadows[`shadow-xl-1`], color: `rgba(0, 0, 0, 0.08)`})}, ${toShadow({
    ...tokens.core.shadows[`shadow-xl-2`],
    color: `rgba(0, 0, 0, 0.06)`,
  })}`,
  xxl: `${toShadow({...tokens.core.shadows[`shadow-xxl-1`]})}, ${toShadow({...tokens.core.shadows[`shadow-xxl-2`]})}`,
};
